import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { ProgressByCategoryOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  overviewData: ProgressByCategoryOverviewReportData['overview']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const StudentProgressByCategoryOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard class="text-left">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.category"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.questionsAnswered"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.averageScore"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      <tr>
        <td class="p-3 text-left">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.progressCategories.literal"}}
        </td>
        <td class="p-3">{{formatValue @overviewData.categories.literal.questions_answered}}</td>
        <td class="p-3">{{formatValue @overviewData.categories.literal.average_score append="%"}}</td>
      </tr>
      <tr>
        <td class="p-3 text-left">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.progressCategories.inferential"}}
        </td>
        <td class="p-3">{{formatValue @overviewData.categories.inferential.questions_answered}}</td>
        <td class="p-3">{{formatValue @overviewData.categories.inferential.average_score append="%"}}</td>
      </tr>
      <tr>
        <td class="p-3 text-left">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.progressCategories.vocabulary"}}
        </td>
        <td class="p-3">{{formatValue @overviewData.categories.vocabulary_and_usage.questions_answered}}</td>
        <td class="p-3">{{formatValue @overviewData.categories.vocabulary_and_usage.average_score append="%"}}</td>
      </tr>
      <tr>
        <td class="p-3 text-left">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.progressCategories.textAnalysis"}}
        </td>
        <td class="p-3">{{formatValue
            @overviewData.categories.text_analysis_and_critical_literacy.questions_answered
          }}</td>
        <td class="p-3">{{formatValue
            @overviewData.categories.text_analysis_and_critical_literacy.average_score
            append="%"
          }}</td>
      </tr>
    </tbody>
  </table>
</template>

export default StudentProgressByCategoryOverview
